// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export type RuntimeModeEnvRecord = Record<string, string | boolean | undefined>;

function isProductionBuildEnv(buildEnv: RuntimeModeEnvRecord): boolean {
  return buildEnv.PROD === true;
}

export function resolveTestMode(
  runtimeEnv: RuntimeModeEnvRecord,
  buildEnv: RuntimeModeEnvRecord,
): boolean {
  if (isProductionBuildEnv(buildEnv)) {
    return false;
  }
  return runtimeEnv.MODE === "test" || buildEnv.MODE === "test";
}

export function resolveDevelopmentMode(
  runtimeEnv: RuntimeModeEnvRecord,
  buildEnv: RuntimeModeEnvRecord,
): boolean {
  if (isProductionBuildEnv(buildEnv)) {
    return false;
  }
  return (
    runtimeEnv.DEV === "true" ||
    runtimeEnv.MODE === "development" ||
    buildEnv.DEV === true ||
    buildEnv.MODE === "development"
  );
}
